import {Injectable} from '@angular/core';

import MapPercentageService from '@app/core/services/map-percentage/map-percentage.service';

@Injectable({providedIn: 'root'})
export default class MapPercentageFacade {
  public enableAll       = this._service.enableAll.bind(this._service);
  public mapPercentage$  = this._service.mapPercentage$;
  public mapPercentages$ = this._service.mapPercentages$;

  constructor(private readonly _service: MapPercentageService) {
  }

  public updateMapPercentage(value: number | string): void {
    this._service.updateMapPercentage(value);
  }
}
